import React from 'react';
import { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import AddressTemplate from '@components/Address/Address';
import ContactTemplate from '@components/ContactForm/ContactForm';
import HeroTemplate from '@components/ContactHero/Hero';
import ContactQuestionsTemplate from '@components/ContactQuestions/ContactQuestions';
import FooterTemplate from '@components/Footer/Footer';
import HeaderTemplate from '@components/Header/Header';
import TeamTemplate from '@components/Team/Team';
import useTranslations from '@hooks/useTranslation';
import { publicAssets } from '@utils/url.utils';
import { IS_PROD } from '../constants';

interface IContact {}

const Contacts: NextPage<IContact> = () => {
    const { t } = useTranslations();

    return (
        <>
            <NextSeo
                title={t('seo.contact.title')}
                description={t('seo.contact.description')}
                noindex={!IS_PROD}
                nofollow={!IS_PROD}
                openGraph={{
                    images: [{ url: `https://profivzdelavanie.sk${publicAssets('/og-konferencia.png')}` }],
                }}
            />
            <HeaderTemplate />
            <HeroTemplate />
            <ContactQuestionsTemplate />
            <AddressTemplate />
            <TeamTemplate />
            <ContactTemplate />
            <FooterTemplate />
        </>
    );
};

export default Contacts;
